import fetch from '../../utils/fetch';
import { getUserToken } from '../../utils/helpers';
import { API_ROUTES } from '../../utils/constants';


export const updateCardAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  const formData = new FormData();
  formData.append('cardToken', data.token);
  return fetch({
    method: 'POST', route: API_ROUTES.PAYMENT_CARD, data: formData, requestHeaders: headers, basic: false,
  });
};

export const updateInvoiceAPI = ({ bankName, country }) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  const formData = new FormData();
  formData.append('bankName', bankName);
  formData.append('country', country);
  return fetch({
    method: 'POST', route: API_ROUTES.PAYMENT_INVOICE, data: formData, requestHeaders: headers, basic: false,
  });
};

export const refillBalanceAPI = ({ amount, userId, reason }) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };

  const formData = new FormData();
  formData.append('amount', amount);
  let route = API_ROUTES.PAYMENT_REFILL;
  if (userId) {
    route = `${API_ROUTES.USERS}/${userId}${API_ROUTES.PAYMENT_REFILL}`;
    formData.append('reason', reason);
  }

  return fetch({
    method: 'POST', route, data: formData, requestHeaders: headers, basic: false,
  });
};

export const deleteCardAPI = () => {
  const accessToken = getUserToken().access_token;
  const headers = {

    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'DELETE', route: API_ROUTES.PAYMENT_CARD, requestHeaders: headers, basic: false,
  });
};

export const deleteInvoiceAPI = () => {
  const accessToken = getUserToken().access_token;
  const headers = {

    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'DELETE', route: API_ROUTES.PAYMENT_INVOICE, requestHeaders: headers, basic: false,
  });
};

export const getUserBalanceHistoryAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  let route = `${API_ROUTES.BALANCE_HISTORY}`;
  const newParams = { ...params };
  if (newParams.userId) {
    route = `${API_ROUTES.USERS}/${newParams.userId}${API_ROUTES.BALANCE_HISTORY}`;
    delete newParams.userId;
  }

  return fetch({
    method: 'GET', route, params: newParams, requestHeaders: headers, basic: false,
  });
};



// WEBPACK FOOTER //
// ./src/reducers/payment/api.js